import React from "react";
import { Mail, PhoneCall } from "react-feather";

const LoginContent = () => {
  return (
    <>
      <h1 className="display-3 text-start">
        Make Your Financial <br /> Management <br /> Easier
      </h1>
      <ul className="d-flex m-0 p-0">
        <li className="me-4 fs-5">
          <PhoneCall className="me-3" size={16} />
          +971 522774554
        </li>
        <li className="me-4 text-link fs-5">
          <Mail className="me-3" size={16} />
          help@moxey.ai
        </li>
      </ul>
    </>
  );
};

export default LoginContent;
